import { render, staticRenderFns } from "./EmailConfirmationModal.vue?vue&type=template&id=7cff8f3d&scoped=true"
import script from "./EmailConfirmationModal.vue?vue&type=script&lang=js"
export * from "./EmailConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./EmailConfirmationModal.vue?vue&type=style&index=0&id=7cff8f3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cff8f3d",
  null
  
)

export default component.exports